import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { CheckCircle2, Clock } from "lucide-react";
import { formatDateTime } from "@/lib/format";
import { motion } from "framer-motion";

export default function Submitted() {
  const { state } = useLocation();
  const nav = useNavigate();
  if (!state?.reference_number) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 h-16 flex items-center px-4 sm:px-6 border-b border-border bg-white/90 backdrop-blur-md"><Logo /></header>
      <main className="max-w-xl mx-auto px-4 py-10">
        <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="text-center">
          <div className="mx-auto h-16 w-16 grid place-items-center rounded-full bg-emerald-50 text-emerald-600 mb-4">
            <CheckCircle2 className="h-9 w-9" />
          </div>
          <h1 className="text-2xl font-extrabold tracking-tight">Application submitted successfully.</h1>
          <p className="text-muted-foreground mt-1">Your application is under review.</p>
        </motion.div>

        <Card className="p-6 mt-6 ip-card-shadow" data-testid="submission-confirmation">
          <div className="flex items-center justify-between py-2 border-b border-border/60">
            <span className="text-sm text-muted-foreground">Reference number</span>
            <span className="font-mono font-bold" data-testid="submitted-reference">{state.reference_number}</span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-border/60">
            <span className="text-sm text-muted-foreground">Submitted</span>
            <span className="text-sm font-semibold">{formatDateTime(state.submitted_at)}</span>
          </div>
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-muted-foreground">Status</span>
            <StatusBadge status="UNDER_REVIEW" />
          </div>
          <div className="mt-4 flex gap-2 rounded-lg bg-sky-50 border border-sky-200 p-3 text-sm text-sky-800">
            <Clock className="h-4 w-4 shrink-0 mt-0.5" />
            <p>Estimated review time: <b>1 minute to 30 minutes</b>. We'll update your status on the dashboard.</p>
          </div>
        </Card>

        <Button onClick={() => nav("/")} className="w-full mt-6 h-11" data-testid="go-to-dashboard-button">Go to Dashboard</Button>
      </main>
    </div>
  );
}
